<h1>Jewelry upgrade calculator</h1>

<div class="result-wrapper">
  <div class="side-panel-container">
    <div class="form-container">
      <h2>Data:</h2>
      <div class="input-container">
        <p class="input-label">Simulate X times</p>
        <input
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="simulationCount"
        />
      </div>
      <div class="input-container">
        <p class="input-label">FWC</p>
        <mat-slide-toggle class="checkbox-input" [(ngModel)]="priceProvider.isFwc" />
      </div>
      <div class="input-container">
        <p class="input-label">Pd10</p>
        <mat-slide-toggle class="checkbox-input" [(ngModel)]="isPd10" />
      </div>
      <div class="input-container">
        <p class="input-label">Upgrade event</p>
        <mat-slide-toggle class="checkbox-input" [(ngModel)]="isUpgradingEvent" />
      </div>
      <div class="input-container">
        <p class="input-label">Upgrade bonus %</p>
        <input
          class="data-input"
          type="number"
          [min]="0"
          [max]="9999"
          [(ngModel)]="customUpgradeBonus"
        />
      </div>
      <div class="input-container">
        <p class="input-label">Current upgrade level</p>
        <input
          class="data-input"
          type="number"
          [min]="0"
          [max]="19"
          [(ngModel)]="currentUpgrade"
        />
      </div>
      <div class="input-container">
        <p class="input-label">Target upgrade level</p>
        <input
          class="data-input"
          type="number"
          [min]="1"
          [max]="20"
          [(ngModel)]="targetUpgrade"
        />
      </div>
      <div class="input-container">
        <p class="input-label">Current attempts</p>
        <input
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="currentAttemptsIn"
        />
      </div>
      <div class="input-container">
        <p class="input-label">aPro cost</p>
        <input
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="priceProvider.aProPrice"
        />
      </div>
      <div class="input-container">
        <p class="input-label">pd8 cost</p>
        <input
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="priceProvider.pd8Price"
        />
      </div>
      <div class="button-container">
        <button (click)="SimulateUpgrading()">Calculate</button>
      </div>
    </div>
    <div class="result-container">
      <h2>Results:</h2>
      <div class="results">
        <div class="result-row">
          <p class="bold">Total penya cost:&nbsp;</p>
          <p>{{ GetTotalPenyaCost() / simulationCount | number : "1.0-1" }}</p>
        </div>
        <br />
        <div class="result-row">
          <p class="bold">Total aPro cost:&nbsp;</p>
          <p>
            {{
              (GetAprosUsed() * priceProvider.aProPrice) /
                simulationCount | number : "1.0-1"
            }}
          </p>
        </div>
        <div class="result-row">
          <p class="bold">Total aPro's used:&nbsp;</p>
          <p>{{ GetAprosUsed() / simulationCount | number : "1.0-1" }}</p>
        </div>
        <br />
        <div class="result-row">
          <p class="bold">Total dice cost:&nbsp;</p>
          <p>
            {{
              (GetPd8sUsed() * priceProvider.pd8Price) /
                simulationCount | number : "1.0-1"
            }}
          </p>
        </div>
        <div class="result-row">
          <p class="bold">Total pd8's used:&nbsp;</p>
          <p>{{ GetPd8sUsed() / simulationCount | number : "1.0-1" }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="upgrade-chart">
    <canvas id="upgrade-data-chart"></canvas>
  </div>
</div>
